import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { BrandsDashboardQueryKeys } from "modules/BrandsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useImportBrandsMutation = () => {
  const { t } = useTranslation();

  return useTypedMutation<FormData, unknown>({
    mutationFn: async formData => (await ApiInstance.post("/brands/import", formData, ENV.carBaseURL)).data,
    onSuccess: () => {
      toast.success(t("v8_import_success", "Import Success"));
      typedQueryClient.invalidateQueries(BrandsDashboardQueryKeys.brands);
      typedQueryClient.invalidateQueries(BrandsDashboardQueryKeys.brandGroups);
    }
  });
};
